import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as ErrorMonitor from 'core/ErrorMonitor';

import AuthLayout from 'components/AuthLayout';
import AppLoading from 'components/AppLoading';
import API from 'core/Api';
import { createErrorFromResponse } from 'core/Error';
import PasswordResetForm from './components/PasswordResetForm';

interface IUserProps {
  id: number;
  name: string;
  email: string;
}

const ResetPasswordScreen: FC = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [userInfo, setUserInfo] = useState<IUserProps | null>(null);

  const { passwordResetToken } = useParams<{
    passwordResetToken: string | undefined;
  }>();

  useEffect(() => {
    if (passwordResetToken) {
      API.post('auth/password-reset-info', {
        password_reset_token: passwordResetToken,
      })
        .then(res => {
          const { user } = res.data;
          ErrorMonitor.setUser({ id: user.id, email: user.email });
          setUserInfo({
            id: user.id,
            name: `${user.first_name} ${user.last_name}`,
            email: user.email,
          });
        })
        .catch(err => setError(createErrorFromResponse(err).message))
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);

  if (isLoading) return <AppLoading />;

  return (
    <AuthLayout title={t('auth.resetPassword.title')}>
      {!!error && <p className="text-center text-error text-muted">{error}</p>}
      {!!userInfo && (
        <>
          <h4 className="text-center">{userInfo.name}</h4>
          <p className="text-center">{userInfo.email}</p>
          <PasswordResetForm userInfo={userInfo} />
        </>
      )}
    </AuthLayout>
  );
};
export default ResetPasswordScreen;
